import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {Badge} from '@mantine/core';
import {AiOutlineFilter} from 'react-icons/ai';
import {FlexiButton} from '@flexinet/ui-components';

import {useZonesFilter} from '../hooks/useZonesQuery';
import {FilterDrawer} from '../drawers/FilterDrawer';

// Takes NO props — it reads the module-scoped store directly, which is the
// whole reason that store exists (the button, the drawer and the list hook are
// in three different components).
export const FilterRecordsButton = () => {

    const [opened, setOpened] = useState(false);
    const {filters} = useZonesFilter();

    // Empty values are never stored (see FilterForm), so a key present here is
    // a filter genuinely narrowing the table.
    const activeCount = Object.keys(filters).length;

    return (
        <>
            <div style={{position: 'relative'}}>
                <FlexiButton
                    leftSection={<AiOutlineFilter/>}
                    onClick={() => setOpened(true)}
                >
                    {I18n.get('Filter')}
                </FlexiButton>
                {activeCount > 0 && (
                    <Badge
                        size={'xs'}
                        variant={'filled'}
                        color={'blue'}
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
